export default {
  title: "Support",
  payments: "Pour toute question concernant les paiements, veuillez écrire à {finance_email}.",
  spam: "Important : veuillez vérifier votre dossier « Spam » !",
  other: "Pour toute autre question, veuillez utiliser le formulaire ci-dessous.",
  faq: "foire aux questions",
  faq_notice:
    "Avant d'envoyer votre demande, veuillez consulter nos règles et la section {faq} (FAQ) — la réponse s'y trouve peut-être déjà.",
  response_time:
    "Une réponse peut prendre de 12 heures à 2 jours ouvrés, selon la complexité de la demande et la charge actuelle du support."
};
